import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import Link from '../../../../Abstracts/Link/Link';
export default function EmptyBasketContent() {
  return (
    <>
      <Row className={'pt-5 pb-2'}>
        <Col>
          <p className={'type-message text-center'}>Your basket is empty</p>
        </Col>
      </Row>
      <Row>
        <Col className={'text-center'}>
          <Link
            to={'/newcomer-week/home'}
            underline
            className={'me-4 text-muted fst-italic text-12'}
          >
            Continue shopping
          </Link>
        </Col>
      </Row>
    </>
  );
}
